import axiosClient from '../axiosClient';

const rewardAPI = {
    async getRewardAPI(body) {
        console.log('khiem 2222');
        const url = `/user/get_gift_value`;
        const resp = await axiosClient.post(url, body);
        console.log('khiem 2222');
        return resp;
    },
};

export default rewardAPI;
